import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Notifications';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Notifications extends RpcClass{

    /**
     *  @class Notifications
     *  @alias module:src/server/com/silkplm/rpc/Notifications.Notifications
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param headline {string} 
     * @param body {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     broadcast(headline, body) {
            return RpcClass.rpcCall('/rpc/notifications/broadcast', [headline, body]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     countAll() {
            return RpcClass.rpcCall('/rpc/notifications/count-all', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     countUnread() {
            return RpcClass.rpcCall('/rpc/notifications/count-unread', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     countUnseen() {
            return RpcClass.rpcCall('/rpc/notifications/count-unseen', []);
    }
    /** 
     * @async
     * @param listOfId {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteNotifications(listOfId) {
            return RpcClass.rpcCall('/rpc/notifications/delete-notifications', [listOfId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]>}
     */
     getAll() {
            return RpcClass.rpcCall('/rpc/notifications/get-all', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object>}
     */
     getInfoAboutNotification() {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/notifications/get-info-about-notification', []);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = rawValue
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param limit {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]>}
     */
     getLastNotifications(limit) {
            return RpcClass.rpcCall('/rpc/notifications/get-last-notifications', [limit]);
    }
    /** 
     * @async
     * @param limit {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]>}
     */
     getLastUnread(limit) {
            return RpcClass.rpcCall('/rpc/notifications/get-last-unread', [limit]);
    }
    /** 
     * @async
     * @param limit {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserNotification.UserNotification[]>}
     */
     getLastUnseen(limit) {
            return RpcClass.rpcCall('/rpc/notifications/get-last-unseen', [limit]);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/UserNotification.UserNotification>}
     */
     getNotificationById(id) {
            return RpcClass.rpcCall('/rpc/notifications/get-notification-by-id', [id]);
    }
    /** 
     * @async
     * @param taskId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     insertTaskToCache(taskId) {
            return RpcClass.rpcCall('/rpc/notifications/insert-task-to-cache', [taskId]);
    }
    /** 
     * @async
     * @param maxId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     markAllAsRead(maxId) {
            return RpcClass.rpcCall('/rpc/notifications/mark-all-as-read', [maxId]);
    }
    /** 
     * @async
     * @param notificationId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     markAsRead(notificationId) {
            return RpcClass.rpcCall('/rpc/notifications/mark-as-read', [notificationId]);
    }
    /** 
     * @async
     * @param maxId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     markAsSeen(maxId) {
            return RpcClass.rpcCall('/rpc/notifications/mark-as-seen', [maxId]);
    }
    /** 
     * @async
     * @param userId {string} 
     * @param headline {string} 
     * @param body {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     sendTo(userId, headline, body) {
            return RpcClass.rpcCall('/rpc/notifications/send-to', [userId, headline, body]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Notifications';
metadata.__type_short__ = 'Notifications';
Notifications.prototype.__metadata__ = metadata;

Notifications.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Notifications */
export default Notifications

export { Notifications }
